/* eslint-disable react-hooks/exhaustive-deps */
import cn from 'classnames';
import Image from 'next/image';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import style from './index.module.scss';
import { useRouter } from 'next/router';
import { homeUrl } from 'constants/index';
interface Props {
  defaultIndex: number;
  menu: Array<{
    name: string;
    link: string;
  }>;
  type?: 1 | 2;
}
let timer: number;
const Nav = ({ defaultIndex, menu, type = 1 }: Props) => {
  const [current, setCurrent] = useState(defaultIndex || 0);
  const [sticky, setSticky] = useState(false);
  const [once, setOnce] = useState(false); //首次动画执行
  const count = useRef(0); // 首次动画执行占位不需要过渡效果 0初始状态 1 首次动画执行（自动滚动），其余为手动滚动
  const dom = useRef(null);
  const subNav = useRef<any>();
  const menuRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const onScroll = useCallback(() => {
    const scrollTop = document.documentElement.scrollTop;
    if (scrollTop > 100) {
      count.current++;
      setSticky(true);
      setOnce(false);
      count.current++;
    } else {
      if (count.current >= 1) {
        count.current = 2;
      }
      setSticky(false);
    }
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);

  useEffect(() => {
    if (window.innerWidth > 768) {
      setOnce(true);
      requestAnimation();
    }
  }, []);
  const requestAnimation = () => {
    const scrollTop = document.documentElement.scrollTop;
    const speed = scrollTop > 80 ? 1 : 2;
    timer = window.requestAnimationFrame(() => {
      if (scrollTop > 100) {
        cancelAnimationFrame(timer);
      } else {
        document.documentElement.scrollTop = scrollTop + speed;
        requestAnimation();
      }
    });
  };

  // 移动端-设置当前页面导航按钮是否在可视口完全显示
  useEffect(() => {
    const childNodes = menuRef.current?.childNodes;
    if (childNodes && window.innerWidth < 768) {
      const child = childNodes[current];
      const position = (child as HTMLElement).getClientRects();
      const { left, width } = position[0];
      const diff = left + width - window.innerWidth;
      if (diff > 0) {
        if (menuRef.current) {
          const distance = menuRef.current.scrollLeft + diff + 10;
          menuRef.current.scrollLeft = distance;
        }
      }
    }
  }, []);
  const Goto = (index: number, url: string) => {
    setCurrent(index);
    router.push(url);
    // window.location.href = url;
  };
  return (
    <div>
      <div ref={dom} className={cn(style['nav__theme_parent'], once && style.once, sticky && style.sticky)}>
        <div className={cn(style['logo'], sticky && style.show, !sticky && style.hide)}>
          <a href={homeUrl}>
            <Image src="/v2/images/login-logo.png" alt="logo" width="134" height="27" />
          </a>
        </div>
        <div className={cn(style['nav-pc'])} ref={subNav}>
          {menu.map((item: { name: string; link: string }, index: number) => {
            return (
              <div key={item.name} onClick={() => Goto(index, item.link)} className={cn(style['nav-pc-item'], index === current && style.focus)}>
                {item.name}
              </div>
            );
          })}
        </div>
      </div>
      <div className={cn(style.transition, count.current === 1 && style.once, count.current > 1 && sticky && style.active, 'for-pc')}></div>
      {type === 1 && (
        <div className={style['nav-mob']} ref={menuRef}>
          {menu.map((item: { name: string; link: string }, index: number) => {
            return (
              <div key={item.name} onClick={() => Goto(index, item.link)} className={cn(style['nav-mob-item'], index === current && style.focus)}>
                {item.name}
              </div>
            );
          })}
        </div>
      )}
      {type === 2 && (
        <div className={style['nav-mob-2']}>
          {menu.map((item: { name: string; link: string }, index: number) => {
            return (
              <div key={item.name} onClick={() => Goto(index, item.link)} className={cn(style['nav-mob-item'], index === current && style.focus)}>
                {item.name}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Nav;
